var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.255,
    height: 50,
    viewBox: "0 0 29.255 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_373",
    "data-name": "Rectangle 373",
    width: 50,
    height: 29.255,
    fill: "#fafaf2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(0 50) rotate(-90)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M47.524,10.408a18.135,18.135,0,0,0-4.413-.025q.659.868,1.335,1.716a65.019,65.019,0,0,0-6.881,4.484A93.252,93.252,0,0,1,29.221,4.394Q27.978,2.231,26.843,0q-.9.059-1.843.059T23.157,0q-1.134,2.23-2.378,4.394a93.253,93.253,0,0,1-8.344,12.189A65.02,65.02,0,0,0,5.554,12.1q.676-.848,1.335-1.716a18.13,18.13,0,0,0-4.412.025q-.392.477-.788.948L0,13.359,2.181,14.48A61.628,61.628,0,0,1,11.8,20.635l1.079.839.912-1.089A96.979,96.979,0,0,0,24.349,4.89q.33-.6.651-1.2.321.6.651,1.2A97.021,97.021,0,0,0,36.209,20.384l.912,1.089,1.08-.839a61.627,61.627,0,0,1,9.618-6.155L50,13.359l-1.688-2q-.4-.47-.788-.948",
    transform: "translate(0 0)",
    fill: "#fafaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M31.309,22.9c3.214,6.369,5.17,9.269,5.352,12.688.183-3.419,2.139-6.319,5.352-12.688q-1.129-1.414-2.162-2.932a25.835,25.835,0,0,0-3.19,7.824,25.85,25.85,0,0,0-3.189-7.824q-1.034,1.515-2.163,2.932",
    transform: "translate(-11.662 -6.328)",
    fill: "#fafaf2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRightArrow);
export default __webpack_public_path__ + "static/media/white-right-arrow.719df9cd402770fe85eb0b0198e1dcf2.svg";
export { ForwardRef as ReactComponent };